import controller from './device-content.controller'
import template   from './device-content.html'
import './device-content.styl'

let component = {
  restrict: 'E',
  bindings: {
    content: '<',
    vehicle: '<'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/device-content/device-content.component.js